import { render, staticRenderFns } from "./PublicCalendarListItem.vue?vue&type=template&id=4bed1770"
import script from "./PublicCalendarListItem.vue?vue&type=script&lang=js"
export * from "./PublicCalendarListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports